import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { StorySection } from '../components/sales/StorySection';
import { MistakesSection } from '../components/sales/MistakesSection';
import { MechanismSection } from '../components/sales/MechanismSection';
import { OfferStack } from '../components/sales/OfferStack';
import { AudienceSection } from '../components/sales/AudienceSection';
import { TimelineSection } from '../components/sales/TimelineSection';
import { SocialProof } from '../components/sales/SocialProof';
import { FaqSection } from '../components/sales/FaqSection';
import { PriceBlock } from '../components/sales/PriceBlock';
import { Footer } from '../components/sales/Footer';
export function SalesPage() {
  return <main className="min-h-screen w-full bg-cream selection:bg-orange/30 selection:text-charcoal" data-id="element-262">
      <HeroSection data-id="element-263" />
      <StorySection data-id="element-264" />
      <MistakesSection data-id="element-265" />
      <MechanismSection data-id="element-266" />
      <OfferStack data-id="element-267" />
      <AudienceSection data-id="element-268" />
      <TimelineSection data-id="element-269" />
      <SocialProof data-id="element-270" />
      <FaqSection data-id="element-271" />
      <PriceBlock data-id="element-272" />
      <Footer data-id="element-273" />
    </main>;
}